import './Navbar.css';
// import logo from '../../images/phoenix-unity-designs-horizontal-light.svg';
import { NavLink, Link } from "react-router";

function Navbar() {

const clicked = () => {
  const collapseElement = document.getElementById("navbarSupportedContent")
  if (collapseElement.classList.contains("show")) {
    collapseElement.classList.remove("show")
    document.getElementById('navbar-toggler').classList.add('collapsed')
  }
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'instant',
  })
}

  return (
    <nav className="navbar fixed-top navbar-expand-lg navbar-dark">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/"><img src='/phoenix-unity-designs-horizontal-light.svg' className="phoenix-navbar-logo" alt="Phoenix Unity Designs" onClick={clicked} /></Link>
        <button
          id="navbar-toggler"
          className="navbar-toggler collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <b></b>
          <b></b>
          <b></b>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent" onClick={clicked}>
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                to="/"
                exact={'true'}
                className={({ isActive }) => `nav-link ${isActive && 'active'}`}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/work"
                className={({ isActive }) => `nav-link ${isActive && 'active'}`}
              >
                Work
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/our-process"
                className={({ isActive }) => `nav-link ${isActive && 'active'}`}
              >
                Our Process
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/about"
                className={({ isActive }) => `nav-link ${isActive && 'active'}`}
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/contact"
                className={({ isActive }) => `nav-link ${isActive && 'active'}`}
              >
                Contact
              </NavLink>
            </li>
          </ul>
          {/* TODO: re-add when portfolio is implemented
          <form className="d-flex" role="search">
            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
            <button className="btn btn-outline-success" type="submit">Search</button>
          </form> */}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
